/*
 * Copyright (c) 2025 - 2026. Bluemate B.V.
 */

import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {AppContext} from '../misc/appContext';

import {SubscriptionModuleName} from '../../util/enums';

import {BluemateBadge} from '../controls';

export default function BluemateBadgePremium() {
    const {t} = useTranslation();
    const {user} = useContext(AppContext).userContext;
    const module = user?.subscription?.getModule(SubscriptionModuleName.NOTIFICATIONS);
    const isTrialing = module?.isTrialing();
    return (
        <BluemateBadge
            label={t('notifications.components.premiumBadge', 'Premium')}
            color='gold'
            tooltipClassName='premium-notification-info'
            tooltip={
                <>
                    {t(
                        'notifications.components.premiumInfo',
                        'Deze notificatie is een premium notificatie en is beschikbaar via de Notificaties module.'
                    )}
                    {isTrialing && (
                        <>
                            <br />
                            {t(
                                'notifications.components.premiumTrialInfo',
                                'Gratis te gebruiken gedurende jouw proefperiode.'
                            )}
                        </>
                    )}
                </>
            }
        />
    );
}
